import axios from "axios";
import {api} from "@/config"

export class Authorization {
    static login(data) {
        const dataURL = `${api.url}/gen/auth/login`;
        return axios.post(dataURL, data)
    }
}